import _ from 'lodash';

import { getPosts, getPost, createPost, editPost, deletePost, createBlogElement, editBlogElement, deleteBlogElement } from '../APIClient/blog';
import { getAffiliateLinks } from '../APIClient/pins';

export const GET_BLOG_POST_FAILURE = 'GET_BLOG_POST_FAILURE';
export const GET_BLOG_POST_SUCCESS = 'GET_BLOG_POST_SUCCESS';

export const GET_BLOG_POSTS_FAILURE = 'GET_BLOG_POSTS_FAILURE';
export const GET_BLOG_POSTS_SUCCESS = 'GET_BLOG_POSTS_SUCCESS';

export const CREATE_BLOG_POST_SUCCESS = 'CREATE_BLOG_POST_SUCCESS';
export const DELETE_BLOG_POST_SUCCESS = 'DELETE_BLOG_POST_SUCCESS';

export const EDIT_BLOG_POST_SUCCESS = 'EDIT_BLOG_POST_SUCCESS';
export const EDIT_BLOG_POST_FAILURE = 'EDIT_BLOG_POST_FAILURE';

export const CREATE_BLOG_POST_ELEMENT_SUCCESS = 'CREATE_BLOG_POST_ELEMENT_SUCCESS';
export const DELETE_BLOG_POST_ELEMENT_SUCCESS = 'DELETE_BLOG_POST_ELEMENT_SUCCESS';

export const EDIT_BLOG_POST_ELEMENT_SUCCESS = 'EDIT_BLOG_POST_ELEMENT_SUCCESS';
export const EDIT_BLOG_POST_ELEMENT_FAILURE = 'EDIT_BLOG_POST_ELEMENT_FAILURE';

export const getBlogPost = title => async (dispatch, getState) => {
  try {
    const resp = await getPost(title);
    const post = _.get(resp, 'post', {});
    dispatch({
      type: GET_BLOG_POST_SUCCESS,
      post
    });

    // Augment with affiliate links
    const postPins = _.filter(_.map(post.elements, 'pin'));
    const affiliateLinkResp = postPins.length ? await getAffiliateLinks(postPins) : {};
    const affiliate_links = _.get(affiliateLinkResp, 'data', {});
    return dispatch({
      type: GET_BLOG_POST_SUCCESS,
      post,
      affiliate_links
    });
  } catch (error) {
    return dispatch({
      type: GET_BLOG_POST_FAILURE,
      error
    });
  }
};

export const getBlogPosts = () => async (dispatch, getState) => {
  try {
    const posts = await getPosts();
    return dispatch({
      type: GET_BLOG_POSTS_SUCCESS,
      posts
    });
  } catch (error) {
    return dispatch({
      type: GET_BLOG_POSTS_FAILURE,
      error
    });
  }
};

export const createBlogPost = () => async (dispatch, getState) => {
  const post = await createPost();
  return dispatch({
    type: CREATE_BLOG_POST_SUCCESS,
    post
  });
};

export const deleteBlogPost = post => async (dispatch, getState) => {
  await deletePost(post);
  return dispatch({
    type: DELETE_BLOG_POST_SUCCESS,
    post
  });
};

export const editBlogPost = (post, updates) => async (dispatch, getState) => {
  const newPost = await editPost(post, updates);
  if (!newPost) {
    return dispatch({
      type: EDIT_BLOG_POST_FAILURE,
      error: 'We had an issue updating this blog post.'
    });
  }

  return dispatch({
    type: EDIT_BLOG_POST_SUCCESS,
    post: newPost
  });
};

export const createBlogPostElement = (post, type) => async (dispatch, getState) => {
  const element = await createBlogElement(post, type);
  return dispatch({
    type: CREATE_BLOG_POST_ELEMENT_SUCCESS,
    post,
    element
  });
};

export const deleteBlogPostElement = element => async (dispatch, getState) => {
  await deleteBlogElement(element);
  return dispatch({
    type: DELETE_BLOG_POST_ELEMENT_SUCCESS,
    element
  });
};

export const editBlogPostElement = (element, updates) => async (dispatch, getState) => {
  const newElement = await editBlogElement(element, updates);
  if (!newElement) {
    return dispatch({
      type: EDIT_BLOG_POST_ELEMENT_FAILURE,
      error: 'We had an issue updating this blog post element.'
    });
  }

  return dispatch({
    type: EDIT_BLOG_POST_ELEMENT_SUCCESS,
    element: newElement
  });
};
